/* ARCARA · shared behaviour. Scroll reveals only — everything else is Prestige. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(scope) {
    var nodes = (scope || document).querySelectorAll('[data-arc-rev]:not(.is-in)');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    for (var j = 0; j < nodes.length; j++) {
      nodes[j].style.transitionDelay = (Math.min(j, 6) * 70) + 'ms';
      io.observe(nodes[j]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () { reveal(); });
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
